import { DEFAULT_CURRENCY } from "../../common/commonStrings";
import { IProductWithCmsDataAndQualification } from "../../pages/ProductsListPage/entities/product-with-cms-data-and-qualification/product-with-cms-data-and-qualification.entity.interface";
import { ICmsProductValueDto } from "../ApiClientBonusxCmsRepository/dtos/cms-product-value/cms-product-value.dto.interface";
import { IProductCashbackForPartner, ProductIdentifierWithCashbackType } from "./ProductCashbackForPartner.interface";

const DEFAULT_PRODUCTS: IProductWithCmsDataAndQualification[] = [];
export class ProductCashbackForPartner implements IProductCashbackForPartner {
  constructor(private readonly _products: IProductWithCmsDataAndQualification[] = DEFAULT_PRODUCTS) {}
  getProductsCashbackFromPartner(currency: string = DEFAULT_CURRENCY) {
    const DEFAULT_PRODUCT_WITH_CASHBACK_COLLECTION: ProductIdentifierWithCashbackType[] = [];
    const productIdentifierWithCashbackCollection: ProductIdentifierWithCashbackType[] = this._products.reduce(
      this._getProductCashbackByCurrency.bind(this, currency),
      DEFAULT_PRODUCT_WITH_CASHBACK_COLLECTION
    );

    return productIdentifierWithCashbackCollection;
  }

  private _getProductCashbackByCurrency(
    this: ProductCashbackForPartner,
    currency: string,
    acc: ProductIdentifierWithCashbackType[],
    product: IProductWithCmsDataAndQualification
  ): ProductIdentifierWithCashbackType[] {
    const uniqueIdentifier = product.cms?.uniqueIdentifier ?? product.unique_identifier;

    const productValueByCurrency = product.cms?.cashbackFromPartner.reduce(
      this._chooseProductValueByCurrency.bind(this, currency),
      null
    );

    if (productValueByCurrency) {
      const productIdentifierWithCashback: ProductIdentifierWithCashbackType = [
        uniqueIdentifier,
        productValueByCurrency,
      ];

      acc.push(productIdentifierWithCashback);
    }

    return acc;
  }

  private _chooseProductValueByCurrency(
    currency: string,
    acc: ICmsProductValueDto | null,
    productValue: ICmsProductValueDto
  ) {
    if (productValue.currency === currency) {
      return productValue;
    }

    return acc;
  }
}
